/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { SkipApplicationPropertyType } from './types.tsx';

export const getOnboardingSkipApplicationProperty = (): Promise<SkipApplicationPropertyType> =>
	performGetRequest('/rest/onboarding/1.0/skip');
